import { Menu as AntMenu } from 'antd';
import styled, { createGlobalStyle } from 'styled-components';
import { theme } from '../../theme/semanticTokens';
import { Typography } from '../../Typography';

export const StyledMenu = styled(AntMenu)`
  background-color: transparent;
  border: none;
  padding: 0;
  min-width: 180px;

  /* Remove default Ant Design menu styling */
  &.ant-menu {
    background: transparent;
    border: none;
    min-width: 180px;
  }

  .ant-menu-item {
    margin: 0 0 4px 0;
    min-width: 180px !important;
    width: 100% !important;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .ant-menu-submenu-title {
    min-width: 180px !important;
    width: 100% !important;

    /* Ensure title content has full width */
    .ant-menu-title-content {
      width: 100% !important;
    }
  }

  /* Style menu divider */
  .ant-menu-item-divider {
    margin: ${theme.dime.spacing.m} 0;
    border-color: ${theme.dime.colors.border.static};
    border-top: 1px solid ${theme.dime.colors.border.static};
    border-bottom: none;
  }

  /* Remove default menu border */
  &.ant-menu-vertical {
    border-right: none;
    border: none !important;
  }
`;

export const MenuTitle = styled(Typography)`
  color: ${theme.dime.colors.text.secondary};
  margin-bottom: ${theme.dime.spacing.m};
  padding: ${theme.dime.spacing.m} ${theme.dime.spacing.s}
    ${theme.dime.spacing.s} ${theme.dime.spacing.m};
  display: block;
`;

export const MenuContainer = styled.div`
  background-color: ${theme.dime.colors.surface.primary};
  border-radius: ${theme.dime.radius.m};
  border: 1px solid ${theme.dime.colors.border.static};
  box-shadow: 0px 0px 14px 0px rgba(0, 0, 0, 0.08);

  width: 100%;
  min-width: 180px;
  overflow: hidden;

  /* Padding when title exists */
  &.has-title {
    padding: ${theme.dime.spacing.s};
  }
`;

/* Global styles for submenu popup - Ant Design creates these in a portal */
export const SubMenuPopupGlobalStyles = createGlobalStyle`
  .ant-menu-submenu-popup {
    .ant-menu {
      background-color: ${theme.dime.colors.surface.primary} !important;
      border-radius: ${theme.dime.radius.m} !important;
      border: 1px solid ${theme.dime.colors.border.static} !important;
      box-shadow: 0px 0px 14px 0px rgba(0, 0, 0, 0.08) !important;
      padding: ${theme.dime.spacing.s} !important;
      margin: ${theme.dime.spacing.s} !important;
      overflow: hidden !important;
      min-width: 180px !important;
      
      .ant-menu-item {
        min-width: 180px !important;
        width: 100% !important;
        margin: 0 0 4px 0 !important;

        &:last-child {
          margin-bottom: 0 !important;
        }
      }
    }
  }
`;
